import React from 'react';

function Logo({ className = "w-8 h-8", color = "#00F0FF" }) {
  return (
    <svg 
      className={className}
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Ledger/Book Base */}
      <path 
        d="M8 8C8 6.89543 8.89543 6 10 6H34C35.1046 6 36 6.89543 36 8V40C36 41.1046 35.1046 42 34 42H10C8.89543 42 8 41.1046 8 40V8Z" 
        stroke={color} 
        strokeWidth="2" 
        fill="none"
      />
      
      {/* Book Spine */}
      <path d="M12 6V42" stroke={color} strokeWidth="2"/>
      
      {/* Circuit Lines on Book (Data entries) */}
      <path d="M18 14H30" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18 20H28" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18 26H26" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      
      {/* AI Neural Nodes */}
      <circle cx="32" cy="14" r="2" fill={color}/>
      <circle cx="30" cy="20" r="2" fill={color}/>
      <circle cx="28" cy="26" r="2" fill={color}/>
      
      {/* Connecting Circuit Lines */}
      <path d="M32 16V18L30 20" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      <path d="M30 22V24L28 26" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      
      {/* AI Chip Element */}
      <rect x="38" y="16" width="8" height="8" rx="1" stroke={color} strokeWidth="1.5" fill="none"/>
      <circle cx="42" cy="20" r="2" fill={color}/>
      
      {/* Connection from book to chip */}
      <path d="M36 20H38" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      
      {/* Data flow dot */}
      <circle cx="37" cy="20" r="0.8" fill={color} opacity="0.6"/>
      
      {/* Chip pins */}
      <path d="M40 16V14" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      <path d="M44 16V14" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      <path d="M40 24V26" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      <path d="M44 24V26" stroke={color} strokeWidth="1" strokeLinecap="round"/>
      
      {/* Fading data lines */}
      <path d="M18 32H24" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <path d="M18 36H22" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.3"/>
    </svg>
  );
}

export default Logo;
